import { Avatar, Card, Col, Form, Input, notification, Row, Spin } from 'antd';
import React, { useRef, useState } from 'react';
import imgAvatar from "./../../assets/img/avatarImg.png";
import "./utilisateur.css";
import Title from 'antd/es/typography/Title';
import BtnSimpl from '../../components/buttons/BtnSimpl';
import { CodeSandboxSquareFilled, HighlightOutlined, IdcardFilled, ProfileFilled, ProfileOutlined, RocketFilled, SolutionOutlined } from '@ant-design/icons';
import { useDispatch, useSelector,  } from 'react-redux';
import { updateUtilisateurPassword } from '../../redux/actions/UpdateUtilisateurPasswordActions';
import { updateUtilisateur } from '../../redux/actions/UpdateUtilisateursActions';

const ProfilUtilisateur = () => {

const [oldPassword, setOldPassword] = useState();
const [newPassword, setNewPassword] = useState();
const [confirmPassword, setConfirmPassword] = useState();
const dispatch = useDispatch();
const [form] = Form.useForm();
const [editableProfil, setEditableProfil] = useState(false);
const passwordSectionRef = useRef(null);
const profilSectionRef = useRef(null);
const basicSectionRef = useRef(null);
const [highlightedSection, setHighlightedSection] = useState('');
const [selectedSection, setSelectedSection] = useState('profil');


const scrollToprofilSection = () => {
  profilSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  // setHighlightedSection('profil');
  setSelectedSection('profil');
  // setTimeout(() => setHighlightedSection(''), 2000);
};

const scrollTobasicSection = () => {
  basicSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  // setHighlightedSection('basic');
  setSelectedSection('basic');
  // setTimeout(() => setHighlightedSection(''), 2000);
};

const scrollToPasswordSection = () => {
  passwordSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  // setHighlightedSection('password');
  setSelectedSection('password');
  // setTimeout(() => setHighlightedSection(''), 2000);
};





 const userData = JSON.parse(localStorage.getItem('user'));
    const userId = userData.id;

      const [InputDataProfil, setInputDataProfil] = useState({
      prenom: userData?.prenom || '',
      nom: userData?.nom || '',
      username: userData?.username || '',
      email: userData?.email || '',
    });
    const handleChangeInputProfil = (e) => {
        const {name, value} = e.target;
        setInputDataProfil({
          ...InputDataProfil,
          [name]:value
        });
    };

      const { loading: updatePwdLoading } = useSelector((state) => state.updateUtilisateurPassword);

 const handleSubmitPassword = async () => {
    
      const updatedPassword = {
        userId:userId,
        oldPassword: oldPassword,
        newPassword: newPassword,
      };

      if (newPassword !== confirmPassword) {
        notification.warning({
          message: "Le nouveau mot de passe et le mot de passe de confirmation doivent être identiques.",
          duration: 8,
        });
        return;
      }
    
      try {
       const response = await dispatch(updateUtilisateurPassword(updatedPassword));
        
       if (response) {
            form.resetFields();
       }

      } catch (error) {
      }
    };
      const { loading: editeLoading } = useSelector((state) => state.updateUtilisateur);

    const handleEditUtilisateur = async () => {
        const updatedUserData = {
            userId: userId,
            prenom: InputDataProfil.prenom,
            nom: InputDataProfil.nom,
            username: InputDataProfil.username,
            email: InputDataProfil.email,
        };
        console.log(updatedUserData);
          try {
           const response = await dispatch(updateUtilisateur(updatedUserData));
             localStorage.setItem("user", JSON.stringify(response.user));
            setEditableProfil(false)
            // await dispatch(fetchUtilisateurs());
        
          } catch (err) {
          //  console.log(err);
          }
        };


    return (
    <div className='divGlabaleP'>
        <Row gutter={10} >
            <Col span={7}>
                <Card className='colProfilSexion0'>
                    <Title level={5} style={{marginTop:"-0.5%", cursor: 'pointer', marginLeft:"-3%", color: selectedSection === 'profil' ? '#43CE0C' : undefined }} onClick={scrollToprofilSection}><SolutionOutlined   style={{fontSize:"25px", marginRight:"5%"}} />Profil</Title><br/>
                    <Title level={5} style={{ cursor: 'pointer', marginLeft:"-3%", color: selectedSection === 'basic' ? '#43CE0C' : undefined  }} onClick={scrollTobasicSection}><ProfileOutlined style={{fontSize:"25px", marginRight:"5%"}} />Informations basic</Title><br/>
                    <Title level={5} style={{ cursor: 'pointer', marginLeft:"-3%", color: selectedSection === 'password' ? '#43CE0C' : undefined }} onClick={scrollToPasswordSection}><HighlightOutlined style={{ fontSize: "25px", marginRight: "5%" }} />Modifier mot de passe</Title>
                </Card>
            </Col>

                    <Col span={17}>
                        <Card className={`colProfilSexion1 ${selectedSection === 'profil' ? 'highlight-section' : ''}`} ref={profilSectionRef}>
                            <div className='divContain'>
                            <Avatar size={70} shape="square" style={{borderRadius:"1rem" }}
                            ><img src={imgAvatar} alt="imag"/></Avatar>
                            <div className='divText'><Title level={4}>{userData?.prenom} {userData?.nom}</Title>
                            {/* <p style={{marginTop:"-6%", marginBottom:"0%"}}>Role / {userData?.role} </p> */}
                            </div>
                            </div>
                        </Card>

                        <Card className={`colProfilSexion2 ${selectedSection === 'basic' ? 'highlight-section' : ''}`} ref={basicSectionRef}>
                            <Title level={4} style={{marginTop:"-0.8%", marginBottom:"4%"}}>Informations basic</Title>
                            
                       <Form layout="vertical">
                        <Row gutter={30}>
                            <Col span={12}>
                            <Form.Item label="Prénom">
                                <Input name="prenom"
                                placeholder="Prenom"
                                value={InputDataProfil.prenom}
                                onChange={handleChangeInputProfil}
                                style={{ padding: "1%" }}
                                disabled={!editableProfil}
                                />
                            </Form.Item>
                            <Form.Item  label="Nom d'utilisateur">
                                <Input name="username"
                                placeholder="Nom d'utilisateur"
                                value={InputDataProfil.username}
                                onChange={handleChangeInputProfil}
                                style={{ padding: "1%" }}
                                disabled
                                />
                            </Form.Item>
                            </Col>

                            <Col span={12}>
                            <Form.Item label="Nom">
                                <Input name="nom"
                                placeholder="Nom"
                                value={InputDataProfil.nom}
                                onChange={handleChangeInputProfil}
                                style={{ padding: "1%" }}
                                disabled={!editableProfil}
                                />
                            </Form.Item>
                            <Form.Item label="Email">
                                <Input name="email"
                                placeholder="Adresse e-mail"
                                value={InputDataProfil.email}
                                onChange={handleChangeInputProfil}
                                style={{ padding: "1%" }}
                                disabled
                                />
                            </Form.Item>

                            {editableProfil ? (
                                 <Spin className="spinLoading" style={{marginLeft:"33%", marginTop:"6%"}} spinning={editeLoading} tip="Enregistrement en cours..." size="large">
                                <BtnSimpl
                                float_="right"
                                buttonText_="Enregistrer"
                                backgroundColor_="#43CE0C"
                                padding_="3%"
                                htmlType_="submit"
                                borderRadius_="0.5rem"
                                color_="#ffffff"
                                boldColor_="bold"
                                fontSize_="100%"
                                onClick_={handleEditUtilisateur}
                                disabled_={editeLoading}
                                /></Spin>
                            ) : (
                                <BtnSimpl
                                float_="right"
                                buttonText_="Modifier"
                                backgroundColor_="#43CE0C"
                                padding_="3%"
                                htmlType_="button"
                                borderRadius_="0.5rem"
                                color_="#ffffff"
                                boldColor_="bold"
                                fontSize_="100%"
                                onClick_={() => setEditableProfil(true)} 
                                />
                            )}
                            </Col>
                        </Row>
                        </Form>

                            
                        </Card>

                        <Card className={`colProfilSexion2 ${selectedSection === 'password' ? 'highlight-section' : ''}`} ref={passwordSectionRef}>
                            <Title level={4} style={{marginTop:"-0.8%", marginBottom:"4%"}}>Changer de mot de passe</Title>
                           
                            <Form form={form} layout="vertical" onFinish={handleSubmitPassword} >
                     
                                    <Form.Item name="oldPassword" label="Ancien mot de passe" rules={[{ required: true, message: "Veuillez saisir l'ancien mot de passe" }]} >
                                        <Input.Password placeholder="Ancien mot de passe"  value={oldPassword}  onChange={(e) => setOldPassword(e.target.value)}  style={{ padding: "1%" }} />
                                    </Form.Item>

                                    <Form.Item name="newPassword" label="Nouveau mot de passe" rules={[{ required: true, message: "Veuillez saisir le nouveau mot de passe" }]} >
                                        <Input.Password  placeholder="Nouveau mot de passe" value={newPassword}  onChange={(e) => setNewPassword(e.target.value)} style={{padding:"1%", }} />
                                    </Form.Item>
                                     <Form.Item name="confirmPassword" label="Confirmer mot de passe" rules={[{ required: true, message: "Veuillez saisir le mot de passe de Confirmation" }]} >
                                        <Input.Password  placeholder="Confirmer mot de passe" value={confirmPassword}  onChange={(e) => setConfirmPassword(e.target.value)} style={{padding:"1%", }} />
                                    </Form.Item>
                                   
                                    <Title level={4} style={{marginTop:"-0.8%", marginBottom:"4%"}}>Exigences de mot de passe</Title>
                                    <p style={{fontSize:"16px"}}>Veuillez suivre ce guide pour un mot de passe fort</p>
                                    <ul>
                                    <li>Un caractère spécial</li>
                                    <li>6 caractères au minimum</li>
                                    <li>Un numéro (2 sont recommandés)</li>
                                    <li>Changez-le souvent</li>
                                    </ul>
                                <Spin className="spinLoading" style={{marginLeft:"33%", marginTop:"6%"}} spinning={updatePwdLoading} tip="Enregistrement en cours..." size="large">
                                    <BtnSimpl float_="right" buttonText_="Mettre à jour le mot de passe" backgroundColor_="#43CE0C" 
                                        padding_="3%" htmlType_="submit" borderRadius_="0.5rem" 
                                        color_="#ffffff" 
                                        boldColor_="bold" 
                                        fontSize_="100%"  disabled_={updatePwdLoading} 
                                        /></Spin>

                                </Form>
                        </Card>
                    </Col>
        </Row>
    </div>
    );
};

export default ProfilUtilisateur;